import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  height: 25px;
  width: 25px;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  font-size: .9rem;

  i {
    font-size: .9rem;
    margin: 0;
  }

  .btn-option-sm {
    height: 25px;
    width: 25px;
    font-size: .7rem;

    i {
      font-size: .7rem;
    }
  }
`;

export default function ButtonCircleDropdown(props){
	const { 
    href,
    icon,
    items = [],
    size = "small", // default, small, large
    color = "default" // default, 
	} = props

  let sizeClass = "";
  let colorClass = "";
  
  switch(size){
    case "small":
      sizeClass = "btn-option-sm"
      break;

    case "large":
      sizeClass = "btn-option-lg"
      break;
  }

  switch(color){
    case "default":
      colorClass = "btn-light"
      break;

    case "blue":
      colorClass = "btn-gc-light-blue-dark"
      break;
  }

	return (
    <div className="btn-group">
      <Button 
        type="button"
        className={`btn btn-option text-gc-dark-blue rounded-circle ${sizeClass} ${colorClass}`}
        data-toggle="dropdown" 
        aria-haspopup="true" 
        aria-expanded="false"
      >
        {icon}
      </Button>
      <div className="dropdown-menu dropdown-menu-right text-gc-dark-blue">
        {
          items.map((e, i) => {
            return (
              <a 
                key={i}
                className={"dropdown-item bg-white font-weight-bold small " + e.class + (typeof e.onClick != 'undefined' ? '' : ' js-nav get_part_link')}
                href='#'
                data-target={e.href}
                data-part='+'
                data-id={e.dataId}
                onClick={e.onClick ?? (() => null)}
              >
                {typeof e.text != 'undefined' ? e.text : (e.slug).trad().ucFirst()}
              </a>
            )
          })
        }
      </div>
    </div>
	);
}